import { Injectable } from '@angular/core';
import {
  ValidatorFn, AsyncValidatorFn,
  AbstractControl, ValidationErrors
} from '@angular/forms';
import { Observable, of, timer, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CustomValidators } from './custom-validators';

@Injectable({ providedIn: 'root' })
export class ValidatorFactoryService {

  // registro de validators sync por nombre
  private syncRegistry: Record<string, (...args: unknown[]) => ValidatorFn> = {
    numericOnly:  () => CustomValidators.numericOnly(),
    noWhitespace: () => CustomValidators.noWhitespace(),
    exactLength:  (len) => CustomValidators.exactLength(len as number),
    matchField:   (id)  => CustomValidators.matchField(id as string),
    notPastDate:  () => CustomValidators.notPastDate(),
  };

  // registro de validators async por nombre
  private asyncRegistry: Record<string, (...args: unknown[]) => AsyncValidatorFn> = {};

  constructor(private http: HttpClient) {
    this.registerDefaultAsync();
  }

  // resolver un validator sync por nombre
  resolveSync(name: string, value?: unknown): ValidatorFn | null {
    const factory = this.syncRegistry[name];
    if (!factory) {
      console.warn(`[AdminForms] Validator sync '${name}' no registrado`);
      return null;
    }
    return value !== undefined ? factory(value) : factory();
  }

  // resolver un validator async por nombre
  resolveAsync(name: string, value?: unknown): AsyncValidatorFn | null {
    const factory = this.asyncRegistry[name];
    if (!factory) {
      console.warn(`[AdminForms] Validator async '${name}' no registrado`);
      return null;
    }
    return value !== undefined ? factory(value) : factory();
  }

  // registrar validators externos (desde otros módulos)
  registerSync(name: string, factory: (...args: unknown[]) => ValidatorFn): void {
    this.syncRegistry[name] = factory;
  }

  registerAsync(name: string, factory: (...args: unknown[]) => AsyncValidatorFn): void {
    this.asyncRegistry[name] = factory;
  }

  private registerDefaultAsync(): void {
    // ejemplo: verificar unicidad de email contra API
    this.asyncRegistry['uniqueEmail'] = () =>
      (ctrl: AbstractControl): Observable<ValidationErrors | null> => {
        if (!ctrl.value) return of(null);
        return timer(400).pipe(
          switchMap(() =>
            this.http.get<{ exists: boolean }>(
              `/api/check-email?email=${ctrl.value}`
            )
          ),
          switchMap(res => of(res.exists ? { uniqueEmail: true } : null))
        );
      };
  }
}